function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null);

var _ref3 =
/*#__PURE__*/
React.createElement("title", null, "Yale-logo");

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  className: "cls-1",
  d: "M159.43,32.25c-5.52,0-9.39,4.42-10.71,11.38l19.44-.22C168.16,37.56,164.51,32.25,159.43,32.25Zm-1,45c-11.6,0-20.55-9.16-20.55-22,0-15.69,9.61-26.4,23.2-26.4,10.94,0,17,6.19,17,16v2l-29.82-.23a35.45,35.45,0,0,0-.34,5.64c0,11.27,7.07,18.67,16.47,18.67,5.63,0,8.5-2,12.92-5.75L179,67.72c-6.3,5.75-11.49,9.5-20.55,9.5Zm-51-.88V73.83c5-.33,6.41-1.44,7.29-3.32V13.25c0-3.75-.55-5.3-8.17-6V5L126.77,0l.66,1.88-3.21,4V70.47c1.11,2.21,3.21,3,7.74,3.32v2.54Zm-33.69-17A21,21,0,0,0,73,65.11c0,3.32,1.88,6.63,5.52,6.63,3.31,0,5.19-1.1,8.18-3.42l.11-14.92c-2.88,1.33-10,4.42-13,6Zm22.09,18c-6,0-8.83-4.08-9-7-3.76,4-8.62,7-13.26,7-6,0-11-3.64-11-9.94a17.3,17.3,0,0,1,2.32-8.83l22-8V42.47c0-5-2.32-9.72-7.3-9.72-3,0-5.85,3.64-6.07,9.27l-10,1.61v-1.1c3.31-10,14.25-13.81,19.55-13.81,10,0,13.7,5.3,13.59,13.48l-.33,23.19c-.11,4.53,2.32,5.64,4.53,5.64,1.76,0,3.53-1.11,5.63-3.21V71c-2.43,2.87-6.74,6.29-10.61,6.29ZM59.6,16.29,41.37,47V67.65c2.1,5,7.4,5.64,12.49,5.86v2.87H18.12V73.47c5.08-.22,11.26-1,12.92-4.31V47.83L12.48,16.47C9.28,11.16,6.19,9.4,0,9V6.07H31V8.94c-5.85.34-7.73,1.44-9.39,2.77L38.84,41.53l16.9-29.71C54,10.49,51.66,9.28,45.8,8.94V6.07H72.31V8.94c-6,.23-9.72,2.21-12.81,7.3Z",
  transform: "translate(0 0.04)"
});

var SvgYaleLogo = function SvgYaleLogo(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 178.97 77.41",
    ref: svgRef
  }, props), _ref2, title === undefined ? _ref3 : title ? React.createElement("title", null, title) : null, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgYaleLogo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Yale-logo.0823ea28.svg";
export { ForwardRef as ReactComponent };